import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styled from 'styled-components';
import { AMIGO_PAGUITOS } from '../../../constants';

const ContBoxMember = styled.div`
  font-size: 15px;
  font-weight: bold;
  display: grid;
  align-items: center;
  width: 80%;
  height: 30px;
  border-radius: 4px;
  margin: 0 auto 20px auto;
  padding: 15px 12px 15px 21px;
  box-shadow: 0px 2px 6px 0px rgba(150, 150, 150, 0.3);
  grid-template-columns: .5fr 5fr .5fr;
`;

const ImgPaquetes = styled.img`
  width: 20px;
  height: 30px;
`;

const ImgIcono = styled.img`
  width: 5px;
  height: 8px;`;

const ContBoxNotMember = styled.div`
  font-size: 14px;
  font-weight: bold;
  align-items: center;
  width: 90%;
  height: auto;
  border-radius: 8px;
  margin: 0 auto 26px auto;
  box-shadow: 0px 0px 23px 0px rgba(1, 32, 36, 0.15);
  padding-bottom: 4%
  padding-top: 4%
`;

const MbPromo = styled.div`
    font-size: 9px;
    color: #fff;
    font-family: 'Amx-Regular';
    background: rgb(37, 74, 165);
    text-align: center;
    border-radius: 0px 5px 2px 18px;
    padding: 2%;
    float: right;
    margin-top: -4.5%
`;

class ContPacks extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      imgPaqueteAmigo: '/images/paquete.svg',
      imgRecargaSaldo: '/images/saldo.svg',
      imgPaqueteInternet: '/images/internet.svg',
      imgPagaPlan: '/images/plan.svg',
      imgMemberPaqueteAmigo: '/images/iconoTelefonoMensajes.svg',
      imgMemberRecargaSaldo: '/images/iconoTelefonoRecarga.svg',
      imgMemberPaqueteInternet: '/images/iconoTelefonoInternet.svg',
      imgMemberPagaPlan: '/images/iconoTelefonoRecarga.svg',
      imgIcono: '/images/icono_flecha_red.svg',
      imgAmigoPaguitos: '/images/Icon_pagar_amigo_paguiitos.svg'
    }
  }

  render() {
    return(
      <>
        {this.props.payments.isClaroPartner ?
          <ContBoxMember>
            {this.props.serviceId == 143 ?
              <ImgPaquetes src={this.state.imgRecargaSaldo} /> : null }
            {this.props.serviceId == 113 ?
              <ImgPaquetes src={this.state.imgPagaPlan} /> : null }
            {this.props.serviceId == 3 ?
              <ImgPaquetes src={this.state.imgPaqueteInternet} /> : null }
            {this.props.serviceId == 8 ?
              <ImgPaquetes src={this.state.imgPaqueteInternet} />: null}
            {this.props.serviceId == 4 ?
              <ImgPaquetes src={this.state.imgPaqueteAmigo} />: null}
            {this.props.serviceId == AMIGO_PAGUITOS ?
              <ImgPaquetes src={this.state.imgAmigoPaguitos} />: null}
            <span style={{marginLeft: '23px'}}>{this.props.title}</span>
            <ImgIcono src={this.state.imgIcono} />
          </ContBoxMember>
        :
        
          <ContBoxNotMember>
            {
              (this.props.hasPromotionMbTelcel)?<MbPromo>{this.props.textPromotionMbTelcel}</MbPromo>:<></>
            }
            <div style={{padding:"15px 12px 15px 21px"}}>
            {this.props.serviceId == 143 ?
              <ImgPaquetes src={this.state.imgMemberRecargaSaldo} /> : null }
            {this.props.serviceId == 113 ?
              <ImgPaquetes src={this.state.imgMemberPagaPlan} /> : null }
            {this.props.serviceId == 3 ?
              <ImgPaquetes src={this.state.imgMemberPaqueteInternet} /> : null }
            {this.props.serviceId == 8 ?
              <ImgPaquetes src={this.state.imgMemberPaqueteInternet} />: null}
            {this.props.serviceId == 4 ?
              <ImgPaquetes src={this.state.imgMemberPaqueteAmigo} />: null}
            {this.props.serviceId == AMIGO_PAGUITOS ?
              <ImgPaquetes src={this.state.imgAmigoPaguitos} />: null}
            <span style={{marginLeft: '13px', verticalAlign: 'super'}}>{this.props.title}</span>
            </div>
          </ContBoxNotMember>
        }
      </>
    )
  }
}

function mapStateToProps(state) {
  return {payments: state.payments.PAYMENT_SERVICE_CONF};
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

ContPacks = connect(
  mapStateToProps,
  mapDispatchToProps
)(ContPacks);

export default ContPacks;